import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../lib/api";
import toast from "react-hot-toast";

export const usePayouts = () => {
    return useQuery({
        queryKey: ["company-payouts"],
        queryFn: async () => {
            const { data } = await api.get("/company/admin/payouts");
            return data.success ? data.data : [];
        },
    });
};

export const usePayout = (id) => {
    return useQuery({
        queryKey: ["company-payout", id],
        queryFn: async () => {
            const { data } = await api.get(`/company/admin/payouts/${id}`);
            return data.success ? data.data : null;
        },
        enabled: !!id,
    });
};

export const usePayPayout = () => {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: (id) => api.put(`/company/admin/payouts/${id}/pay`),
        onSuccess: () => {
            toast.success("Payout marked as paid");
            qc.invalidateQueries({ queryKey: ["admin-payouts"] });
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || "Failed to pay");
        },
    });
};

export const useRejectPayout = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, reason }) =>
            api.put(`/company/admin/payouts/${id}/reject`, { rejection_reason: reason }),
        onSuccess: () => {
            toast.success("Payout rejected");
            qc.invalidateQueries({ queryKey: ["admin-payouts"] });
        },
        onError: (err) => toast.error(err.response?.data?.message || "Failed to reject"),
    });
};